export default "__VITE_ASSET__Cjm2s$J4__"